import React, { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'react-toastify';
import { SubmitHandler } from 'react-hook-form';
import {
  useCreateRole,
  useUpdateRole,
} from '@area-restrita/api-client/endpoints/roles/roles.gen';
import { UpdateRoleBodyDto } from '@area-restrita/api-client/model/updateRoleBodyDto';

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import RoleForm from '../../components/RoleForm';

const CreateRole: React.FC = () => {
  const navigate = useNavigate();

  const createRoleMutation = useCreateRole();
  const updateRoleMutation = useUpdateRole();

  const handleSubmit = useCallback<SubmitHandler<UpdateRoleBodyDto>>(
    (data) =>
      createRoleMutation.mutateAsync(
        { data: { name: data.name } },
        {
          onSuccess: ({ id }) =>
            updateRoleMutation.mutateAsync(
              { id, data },
              {
                onSuccess: () => {
                  toast.success('Função atualizada com sucesso!');
                  navigate({
                    to: '/settings/roles/$roleId',
                    params: { roleId: id },
                  });
                },
                onError: () => {
                  toast.error('Erro ao atualizar função');
                },
              },
            ),
          onError: () => toast.error('Erro ao atualizar função'),
        },
      ),
    [createRoleMutation, updateRoleMutation, navigate],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Criar Nova Função</CardTitle>
        <CardDescription>
          Aqui você pode criar uma nova função e definir suas permissões.
        </CardDescription>
      </CardHeader>
      <RoleForm onSubmit={handleSubmit} />
    </Card>
  );
};

export default CreateRole;
